import i18n from '@/i18n';

import type { HealthCheckFormValues, ProbeType } from './types';

const t = i18n.t.bind(i18n);

/** HTTP 探活请求方式选项 */
export const HTTP_PROBE_METHOD_OPTIONS = [
  { label: 'GET', value: 'GET' },
  { label: 'HTTPS', value: 'HTTPS' },
];

/** 探活类型选项 */
export const PROBE_TYPE_OPTIONS: { label: string; value: ProbeType }[] = [
  { label: t('data-center:probe.type.http'), value: 'http' },
  { label: t('data-center:probe.type.tcp'), value: 'tcp' },
  { label: t('data-center:probe.type.exec'), value: 'exec' },
];

/** 默认探活配置 */
export const DEFAULT_HEALTH_CHECK: HealthCheckFormValues = {
  enabled: false,
  supportedProbeTypes: ['http'],
  defaultProbeType: 'http',
  defaultPort: 8080,
  defaultPath: '/healthz',
  httpMethod: 'GET',
  defaultCommand: '',
  initialDelaySeconds: 30,
  periodSeconds: 10,
  timeoutSeconds: 3,
  failureThreshold: 3,
};
